import React, { useState } from "react";
import { Nav, Tab, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import "./Vendor_Expert_Tabs.css";
import Popular_Vendors from "./popular_vendors/Popular_Vendors";
import Plumber_Expert from "./plumber-expert/Plumber_Expert";
import Painter_Expert from "./painter-experts/Painter_Experts";
import Popular_Expert from "./Popular_experts/Popular_Experts";
import Hardware_Vendors from "./hardware-vendor/Hardware_Vendor";
import Tiles_Vendors from "./tiles-vendor/Tiles_Vendor";
const vendorCategories = [
  { label: "Hardware", img: "/assets/images/Hardware.png" },
  { label: "Tiles", img: "/assets/images/Tiles.png" },
  { label: "Electronics", img: "/assets/images/Electronics.png" },
  { label: "Bricks", img: "/assets/images/Bricks.png" },
  { label: "Cement", img: "/assets/images/Cement.png" },
  { label: "Hardware", img: "/assets/images/Hardware.png" },
  { label: "Tiles", img: "/assets/images/Tiles.png" },
  { label: "Electronics", img: "/assets/images/Electronics.png" },
];
const expertCategories = [
  { label: "Plumber", img: "/assets/images/Plumber.png" },
  { label: "Painter", img: "/assets/images/Painter.png" },
  { label: "Carpenter", img: "/assets/images/Carpainter.png" },
  { label: "Electrician", img: "/assets/images/Electrician.png" },
  { label: "Pest Control", img: "/assets/images/Pest_Control.png" },
];
function Vendor_Expert_Tabs() {
  const [activeTab, setActiveTab] = useState("vendors");
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [selectedExperts, setSelectedExperts] = useState([]);
  const toggleVendor = (index) => {
    setSelectedVendors((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };
  const toggleExpert = (index) => {
    setSelectedExperts((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };
  return (
    <section className="vendor-expert-section">
      <div className="container">
        <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
          <div className="vendor-expert-header">
            <Nav variant="pills" className="vendor-expert-tabs">
              <Nav.Item>
                <Nav.Link eventKey="vendors">Vendors</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="experts">Experts</Nav.Link>
              </Nav.Item>
            </Nav>
            <InputGroup className="vendor-search">
              <InputGroup.Text className="search-icon">
                <FontAwesomeIcon icon={faSearch} />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search"
                className="search-input"
              />
            </InputGroup>
          </div>
          <Tab.Content>
            <Tab.Pane eventKey="vendors">
              <div className="category-scroll-container">
                {vendorCategories.map((item, index) => (
                  <div
                    key={index}
                    className={`category-item ${
                      selectedVendors.includes(index) ? "selected" : ""
                    }`}
                    onClick={() => toggleVendor(index)}
                  >
                    <div className="category-card">
                      <div className="category-img">
                        <img src={item.img} alt={item.label} />
                      </div>
                    </div>
                    <p className="category-label">{item.label}</p>
                  </div>
                ))}
              </div>
              <Popular_Vendors />
              <Hardware_Vendors />
              <Tiles_Vendors />
            </Tab.Pane>
            <Tab.Pane eventKey="experts">
              <div className="category-scroll-container">
                {expertCategories.map((item, index) => (
                  <div
                    key={index}
                    className={`category-item ${
                      selectedExperts.includes(index) ? "selected" : ""
                    }`}
                    onClick={() => toggleExpert(index)}
                  >
                    <div className="category-card">
                      <div className="category-img">
                        <img src={item.img} alt={item.label} />
                      </div>
                    </div>
                    <p className="category-label">{item.label}</p>
                  </div>
                ))}
              </div>
              <Popular_Expert />
              <Plumber_Expert />
              <Painter_Expert />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
}
export default Vendor_Expert_Tabs;
